import "./errorLogging";

import React from "react";
import { render } from "react-dom";

import "./modernizr";

import "typeface-roboto";

import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import ReactGA from "react-ga";
import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";

import thunk from "redux-thunk";
import rootReducer from "./reducers";

import { googleAnalytics } from "./reactGAMiddlewares";

import App from "./App";
import "./css/App.css";
import ScrollToTop from "./components/ScrollToTop";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3"
    }
  },
  overrides: {
    MuiDialog: {
      paper: {
        width: "100%"
      }
    }
  }
});

const history = createBrowserHistory();
history.listen(location => {
  const { hash } = location;
  if (hash !== "") {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element)
        element.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
    }, 100);
  }
});

const debug = process.env.REACT_APP_ENV === "development";

const composeEnhancer = debug
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose;

let store;

ReactGA.initialize("UA-125351715-1", { debug });
if (debug) {
  ReactGA.ga("set", "sendHitTask", null);
}
ReactGA.pageview(window.location.pathname + window.location.search);

store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancer(
    applyMiddleware(routerMiddleware(history), thunk),
    applyMiddleware(googleAnalytics)
  )
);

if (debug) {
  window.fbq = (...args) => console.log("%cfbq:", "color: #bada55", ...args);
} else {
  window.fbq("init", "267272090618983");
  window.fbq("track", "PageView");
}

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MuiThemeProvider theme={theme}>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js